import angular from 'angular';

angular
  .module('cxSettings')
  .controller('TaskParameterDefinitionOptionsDialogCtrl', [
    '$http',
    'appUrls',
    'flySvc',
    'resourceFactorySvc',
    'close',
    'parameterDefinition',
    '$element',
    taskParameterDefinitionOptionsDialogCtrl,
  ]);

function taskParameterDefinitionOptionsDialogCtrl(
  $http,
  appUrls,
  flySvc,
  resourceFactorySvc,
  close,
  parameterDefinition,
  $element,
) {
  var vm = this;
  vm.parameterDefinition = parameterDefinition;
  vm.showValidation = false;
  vm.selectionItems = parameterDefinition.selectionItems
    ? parameterDefinition.selectionItems.split(';').map((x, index) => ({ id: index, value: x }))
    : [];

  vm.updatedItems = vm.selectionItems.map(x => ({
    id: x.id,
    oldValue: x.value,
    newValue: x.value,
    removed: false,
  }));

  vm.addSelectionItem = () => {
    vm.selectionItems.push('');
  };

  vm.removeSelectionItem = (index, id) => {
    vm.updatedItems = vm.updatedItems.map(x => {
      if (x.id === id) {
        return {
          ...x,
          removed: true,
        };
      }

      return x;
    });
    vm.selectionItems.splice(index, 1);
  };

  vm.onSelectionItemChanged = (index, id) => {
    const newValue = vm.selectionItems[index].value.replace(';', '');
    vm.selectionItems[index].value = newValue;

    vm.updatedItems = vm.updatedItems.map(x => {
      if (x.id === id) {
        return {
          ...x,
          newValue: newValue,
        };
      }

      return x;
    });
  };

  vm.save = function() {
    if (vm.parameterDefinition.parameterValueType === 4 && !vm.selectionItems.length) return;
    if (vm.parameterDefinition.parameterValueType === 4) {
      vm.parameterDefinition = {
        ...vm.parameterDefinition,
        selectionItems: vm.selectionItems.map(x => x.value).join(';'),
        selectionItemUpdate: vm.updatedItems,
      };
    }

    vm.saving = true;
    $http.put(`${appUrls.tasks}/api/TaskParameters/UpdateDefinition`, vm.parameterDefinition).then(
      function({ data }) {
        vm.saving = false;
        $element.modal('hide');
        close(data, 500);
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
        return '';
      },
    );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
